// What the site plan's status lines say about each copy of the plan saved to
// SharePoint (marked-up-status.tsx): the marked-up copy and the access plan.
import type { MarkedUpStatus } from './marked-up-plan';

/** What the status line says for one copy of the plan. */
export interface CopyWording {
  status: Record<MarkedUpStatus, string>;
  button: Record<MarkedUpStatus, string>;
  /** The copy's name, mid-sentence: "the marked-up copy". */
  name: string;
}

export const MARKED_UP_WORDING: CopyWording = {
  status: {
    none: 'No marked-up copy (the plan with its pins) on SharePoint yet.',
    current: 'Marked-up copy saved',
    outOfDate: 'Pins have changed since the marked-up copy was saved',
  },
  button: { none: 'Save marked-up copy', current: 'Save marked-up copy', outOfDate: 'Update marked-up copy' },
  name: 'the marked-up copy',
};

export const ACCESS_WORDING: CopyWording = {
  status: {
    none: 'No access plan (the plan with its access lines, for the proposal) on SharePoint yet.',
    current: 'Access plan saved',
    outOfDate: 'Access lines have changed since the access plan was saved',
  },
  button: { none: 'Save access plan', current: 'Save access plan', outOfDate: 'Update access plan' },
  name: 'the access plan',
};
